export default "__VITE_ASSET__Cdc$SV4D__"